import { Tooltip } from "antd";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

export const TenantsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Move In Tenant", "1", "", "", "/people/tenants/move-in-tenant"),
    RightBarMethod("New Owner", "2", "", "", "/people/owners/new"),
    RightBarMethod("New Vendor", "3", "", "", "/people/vendors/new"),
  ]),

  RightBarMethod(
    " REPORTS",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Rent Roll", "4", "", "", "/"),
      RightBarMethod("Tenant Ledger", "5", "", "", "/"),
      RightBarMethod("Tenant Insurance Coverage", "6", "", "", "/"),
    ]
  ),
];

export const tableData = [
  {
    id: 1,
    key: "1",
    name: "Brooks, Anthony",
    status: "Past",
    property: "9626 SE 4th - 9626 SE 4th Midwest City, OK 73130",
    unit: "",
    phone: "",
    tStatus: {
      balance: "0.00",
      lastReceipt: "07/22/2022",
      evicting: "No",
      inCollections: "No",
      certifiedFundsOnly: "No",
      allowOnlinePayments: "No",
      lastIncomeCertification: "Yes",
      requireOnlinePaymentsInFull: "No",
      eligibleForRenewal: "Yes"
    },
    liability: {enrolled: "Not Enrolled"},
    summary: {
      address: "9723 NE 3rd Pl",
      fullAddress: "9723 NE 3rd Pl, Midwest City, OK 73130",
      monthlyCharges: "1,013.00",
      currentBalance: "0.00",
      lastReciept: "07/22/2022",
      moveOutDate: "08/19/2022"
    },
    contact: {
      phoneNumbers: [
        {
          number: "(309) 231-4041  Text",
          type: "phone",
          description: ""
        },
      ],
      emails: [
        {
          email: "mcarey91@gmail.com"
        }
      ],
      addresses: [
        {
          address: "10512 Cattail Terrace",
          addressTwo: "9723 NE 3rd Pl",
          city: "Midwest City",
          state: "OK",
          zipCode: "73130",
          country: "USA"
        }
      ],
      primaryTenant: "Yes",
    },
    tenantStatus: {
      type: "Financially Responsible",
      status: "Past",
      moveIn: "01/13/2017",
      moveOut: "08/19/2022",
      notice: "07/22/2022",
      moveOutReason: "Purchased Home",
      sentRentReminders: "Yes",
      returnType: "Yes"
    },
    onlinePortalStatus: {
      portalActivated: "Yes",
      lastActivationEmail: "01/26/2021",
      autoPayments: "0",
      autoPaymentsTotal: "0.00",
      transactionFee: "Credit: 3.49%, Debit: $9.99, eCheck: Waived",
      twoFactorEnabled: "No",
      optTenantOutofPortal: "No",
      loginEmail: "mcarey91@gmail.com"
    },
    monthlyCharges: [
      {
        key: 1,
        startDate: "08/01/2022",
        endDate: "",
        description: "",
        lastChargedOn: "08/2022",
        nextCharge: "",
        gLAccount: "116: Tenant Benefit Package - New",
        amount: "13.00",
        upcommingCharges: "",
        previousCharge: "13.00 ",
        reversed: "yes",
        chargeDate: "08/01/2022 "
      },
      {
        key: 2,
        startDate: "08/01/2022",
        endDate: "",
        description: "",
        lastChargedOn: "08/2022",
        nextCharge: "",
        gLAccount: "103: Rent Income",
        amount: "1,000.00",
        upcommingCharges: "",
        previousCharge: "1,000.00 ",
        reversed: "yes",
        chargeDate: "08/01/2022 "
      },
    ],
    leaseInformation: {
      leaseSigned: "--",
      monthToMonth: "Yes",
      leaseFrom: "01/13/2017",
      lastLeaseRenewal: "08/01/2022",
      insuranceRequirement: "No",
      leaseDocuments: [
        {
          document: "matthew-carey_07-31-2022.pdf",
          leaseDates: "08/01/2022 -",
          Status: "Fully Executed",
        },
        {
          document: "matthew-carey_07-31-2022.pdf",
          leaseDates: "08/01/2022 -",
          Status: "Fully Executed",
        },
        {
          document: "matthew-carey_07-31-2022.pdf",
          leaseDates: "08/01/2022 -",
          Status: "Fully Executed",
        },
      ],
    },
    financials: {
      depositPaid: "0.00",
      utilityBillingEnabled: "No",
      NSFFee: "45.00",
      EligibleForRentIncreaseOn: "02/01/2021"
    },
    pets: [
      {
        petsName: "Cat",
        type: "Persian",
        weight: "3",
        age: "1"
      },
      {
        petsName: "Dog",
        type: "Dog",
        weight: "4",
        age: "1"
      },
    ],
    vehicles: [
      {
        make: "car",
        model: "civic",
        color: "white",
        licenseNo: "768",
        year: "2013",
        permitNumber: "34"
      },
      {
        make: "car",
        model: "civic",
        color: "white",
        licenseNo: "768",
        year: "2013",
        permitNumber: "34"
      },
      {
        make: "car",
        model: "honda",
        color: "black",
        licenseNo: "768",
        year: "2013",
        permitNumber: "34"
      },
    ],
  tags: [
    {
      tag: "Health Issues"
    },
    {
      tag: "Submitted cdc Form"
    }
  ],
  },
  {
    id: 2,
    key: "2",
    name: "Carey, Matthew",
    status: "Past",
    property: "9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
    unit: "",
    phone: (
      <Tooltip
        placement="bottom"
        title={<p style={{ color: "#000", padding: "10px" }}>(309) 231-4041</p>}
        color={["#fff"]}
      >
        (309) 231-4041
      </Tooltip>
    ),
    tStatus: {
      balance: "0.00",
      lastReceipt: "07/22/2022",
      evicting: "No",
      inCollections: "No",
      certifiedFundsOnly: "No",
      allowOnlinePayments: "No",
      lastIncomeCertification: "Yes",
      requireOnlinePaymentsInFull: "No",
      eligibleForRenewal: "Yes"
    },
    liability: {enrolled: "Not Enrolled"},
    summary: {
      address: "9723 NE 3rd Pl",
      fullAddress: "9723 NE 3rd Pl, Midwest City, OK 73130",
      monthlyCharges: "1,013.00",
      currentBalance: "0.00",
      lastReciept: "07/22/2022",
      moveOutDate: "08/19/2022"
    },
    contact: {
      phoneNumbers: [
        {
          number: "(309) 231-4041",
          type: "phone",
          description: ""
        },
      ],
      emails: [
        {
          email: "mcarey91@gmail.com"
        }
      ],
      addresses: [
        {
          address: "10512 Cattail Terrace",
          addressTwo: "9723 NE 3rd Pl",
          city: "Midwest City",
          state: "OK",
          zipCode: "73130",
          country: "USA"
        }
      ],
      primaryTenant: "Yes",
    },
    tenantStatus: {
      type: "Financially Responsible",
      status: "Past",
      moveIn: "01/13/2017",
      moveOut: "08/19/2022",
      notice: "07/22/2022",
      moveOutReason: "Purchased Home",
      sentRentReminders: "Yes",
      returnType: "Yes"
    },
    onlinePortalStatus: {
      portalActivated: "Yes",
      lastActivationEmail: "01/26/2021",
      autoPayments: "0",
      autoPaymentsTotal: "0.00",
      transactionFee: "Credit: 3.49%, Debit: $9.99, eCheck: Waived",
      twoFactorEnabled: "No",
      optTenantOutofPortal: "No",
      loginEmail: "mcarey91@gmail.com"
    },
    monthlyCharges: [
      {
        startDate: "08/01/2022",
        endDate: "",
        description: "",
        lastChargedOn: "08/2022",
        nextCharge: "",
        gLAccount: "116: Tenant Benefit Package - New",
        amount: "13.00",
        upcommingCharges: "",
        previousCharge: "13.00 ",
        reversed: "yes",
        chargeDate: "08/01/2022 "
      },
      {
        startDate: "08/01/2022",
        endDate: "",
        description: "",
        lastChargedOn: "08/2022",
        nextCharge: "",
        gLAccount: "103: Rent Income",
        amount: "1,000.00",
        upcommingCharges: "",
        previousCharge: "1,000.00 ",
        reversed: "yes",
        chargeDate: "08/01/2022 "
      },
    ],
    leaseInformation: {
      leaseSigned: "--",
      monthToMonth: "Yes",
      leaseFrom: "01/13/2017",
      lastLeaseRenewal: "08/01/2022",
      insuranceRequirement: "No",
      leaseDocuments: [
        {
          document: "matthew-carey_07-31-2022.pdf",
          leaseDates: "08/01/2022 -",
          Status: "Fully Executed",
        },
        {
          document: "matthew-carey_07-31-2022.pdf",
          leaseDates: "08/01/2022 -",
          Status: "Fully Executed",
        },
        {
          document: "matthew-carey_07-31-2022.pdf",
          leaseDates: "08/01/2022 -",
          Status: "Fully Executed",
        },
      ],
    },
    financials: {
      depositPaid: "0.00",
      utilityBillingEnabled: "No",
      NSFFee: "45.00",
      EligibleForRentIncreaseOn: "02/01/2021"
    },
    pets: [
      {
        petsName: "Cat",
        type: "Persian",
        weight: "3",
        age: "1"
      },
      {
        petsName: "Dog",
        type: "Dog",
        weight: "4",
        age: "1"
      },
    ],
    vehicles: [
      {
        make: "car",
        model: "civic",
        color: "white",
        licenseNo: "768",
        year: "2013",
        permitNumber: "34"
      },
      {
        make: "car",
        model: "civic",
        color: "white",
        licenseNo: "768",
        year: "2013",
        permitNumber: "34"
      },
      {
        make: "car",
        model: "honda",
        color: "black",
        licenseNo: "768",
        year: "2013",
        permitNumber: "34"
      },
    ],
    tags: [
      {
        tag: "Health Issues"
      },
      {
        tag: "Submitted cdc Form"
      }
    ],
  },
  {
    id: 3,
    key: "3",
    name: "Casey, William",
    status: "Past",
    property: "9626 SE 4th - 9626 SE 4th Midwest City, OK 73130",
    unit: "",
    phone: "",
    tStatus: {
      balance: "0.00",
      lastReceipt: "07/22/2022",
      evicting: "No",
      inCollections: "No",
      certifiedFundsOnly: "No",
      allowOnlinePayments: "No",
      lastIncomeCertification: "Yes",
      requireOnlinePaymentsInFull: "No",
      eligibleForRenewal: "Yes"
    },
    liability: {enrolled: "Not Enrolled"},
    summary: {
      address: "9723 NE 3rd Pl",
      fullAddress: "9723 NE 3rd Pl, Midwest City, OK 73130",
      monthlyCharges: "1,013.00",
      currentBalance: "0.00",
      lastReciept: "07/22/2022",
      moveOutDate: "08/19/2022"
    },
    contact: {
      phoneNumbers: [
        {
          number: "(309) 231-4041  Text",
          type: "phone",
          description: ""
        },
      ],
      emails: [
        {
          email: "mcarey91@gmail.com"
        }
      ],
      addresses: [
        {
          address: "10512 Cattail Terrace",
          addressTwo: "9723 NE 3rd Pl",
          city: "Midwest City",
          state: "OK",
          zipCode: "73130",
          country: "USA"
        }
      ],
      primaryTenant: "Yes",
    },
    tenantStatus: {
      type: "Financially Responsible",
      status: "Past",
      moveIn: "01/13/2017",
      moveOut: "08/19/2022",
      notice: "07/22/2022",
      moveOutReason: "Purchased Home",
      sentRentReminders: "Yes",
      returnType: "Yes"
    },
    onlinePortalStatus: {
      portalActivated: "Yes",
      lastActivationEmail: "01/26/2021",
      autoPayments: "0",
      autoPaymentsTotal: "0.00",
      transactionFee: "Credit: 3.49%, Debit: $9.99, eCheck: Waived",
      twoFactorEnabled: "No",
      optTenantOutofPortal: "No",
      loginEmail: "mcarey91@gmail.com"
    },
    monthlyCharges: [
      {
        startDate: "08/01/2022",
        endDate: "",
        description: "",
        lastChargedOn: "08/2022",
        nextCharge: "",
        gLAccount: "116: Tenant Benefit Package - New",
        amount: "13.00",
        upcommingCharges: "",
        previousCharge: "13.00 ",
        reversed: "yes",
        chargeDate: "08/01/2022 "
      },
      {
        startDate: "08/01/2022",
        endDate: "",
        description: "",
        lastChargedOn: "08/2022",
        nextCharge: "",
        gLAccount: "103: Rent Income",
        amount: "1,000.00",
        upcommingCharges: "",
        previousCharge: "1,000.00 ",
        reversed: "yes",
        chargeDate: "08/01/2022 "
      },
    ],
    leaseInformation: {
      leaseSigned: "--",
      monthToMonth: "Yes",
      leaseFrom: "01/13/2017",
      lastLeaseRenewal: "08/01/2022",
      insuranceRequirement: "No",
      leaseDocuments: [
        {
          document: "matthew-carey_07-31-2022.pdf",
          leaseDates: "08/01/2022 -",
          Status: "Fully Executed",
        },
        {
          document: "matthew-carey_07-31-2022.pdf",
          leaseDates: "08/01/2022 -",
          Status: "Fully Executed",
        },
        {
          document: "matthew-carey_07-31-2022.pdf",
          leaseDates: "08/01/2022 -",
          Status: "Fully Executed",
        },
      ],
    },
    financials: {
      depositPaid: "0.00",
      utilityBillingEnabled: "No",
      NSFFee: "45.00",
      EligibleForRentIncreaseOn: "02/01/2021"
    },
    pets: [
      {
        petsName: "Cat",
        type: "Persian",
        weight: "3",
        age: "1"
      },
      {
        petsName: "Dog",
        type: "Dog",
        weight: "4",
        age: "1"
      },
    ],
    vehicles: [
      {
        make: "car",
        model: "civic",
        color: "white",
        licenseNo: "768",
        year: "2013",
        permitNumber: "34"
      },
      {
        make: "car",
        model: "civic",
        color: "white",
        licenseNo: "768",
        year: "2013",
        permitNumber: "34"
      },
      {
        make: "car",
        model: "honda",
        color: "black",
        licenseNo: "768",
        year: "2013",
        permitNumber: "34"
      },
    ],
    tags: [
      {
        tag: "Health Issues"
      },
      {
        tag: "Submitted cdc Form"
      }
    ],
  },
  {
    id: 4,
    key: "4",
    name: "Davis, Christopher A.",
    status: "Evict",
    property: "1817 Treat Drive - 1817 Treat Drive Midwest City, OK 73110",
    unit: "",
    phone: (
      <Tooltip
        placement="bottom"
        title={<p style={{ color: "#000", padding: "10px" }}>(405) 763-9521</p>}
        color={["#fff"]}
      >
        (405) 763-9521
      </Tooltip>
    ),
    tStatus: {
      balance: "0.00",
      lastReceipt: "07/22/2022",
      evicting: "No",
      inCollections: "No",
      certifiedFundsOnly: "No",
      allowOnlinePayments: "No",
      lastIncomeCertification: "Yes",
      requireOnlinePaymentsInFull: "No",
      eligibleForRenewal: "Yes"
    },
    liability: {enrolled: "Not Enrolled"},
    summary: {
      address: "9723 NE 3rd Pl",
      fullAddress: "9723 NE 3rd Pl, Midwest City, OK 73130",
      monthlyCharges: "1,013.00",
      currentBalance: "0.00",
      lastReciept: "07/22/2022",
      moveOutDate: "08/19/2022"
    },
    contact: {
      phoneNumbers: [
        {
          number: "(309) 231-4041  Text",
          type: "phone",
          description: ""
        },
      ],
      emails: [
        {
          email: "mcarey91@gmail.com"
        }
      ],
      addresses: [
        {
          address: "10512 Cattail Terrace",
          addressTwo: "9723 NE 3rd Pl",
          city: "Midwest City",
          state: "OK",
          zipCode: "73130",
          country: "USA"
        }
      ],
      primaryTenant: "Yes",
    },
    tenantStatus: {
      type: "Financially Responsible",
      status: "Past",
      moveIn: "01/13/2017",
      moveOut: "08/19/2022",
      notice: "07/22/2022",
      moveOutReason: "Purchased Home",
      sentRentReminders: "Yes",
      returnType: "Yes"
    },
    onlinePortalStatus: {
      portalActivated: "Yes",
      lastActivationEmail: "01/26/2021",
      autoPayments: "0",
      autoPaymentsTotal: "0.00",
      transactionFee: "Credit: 3.49%, Debit: $9.99, eCheck: Waived",
      twoFactorEnabled: "No",
      optTenantOutofPortal: "No",
      loginEmail: "mcarey91@gmail.com"
    },
    monthlyCharges: [
      {
        startDate: "08/01/2022",
        endDate: "",
        description: "",
        lastChargedOn: "08/2022",
        nextCharge: "",
        gLAccount: "116: Tenant Benefit Package - New",
        amount: "13.00",
        upcommingCharges: "",
        previousCharge: "13.00 ",
        reversed: "yes",
        chargeDate: "08/01/2022 "
      },
      {
        startDate: "08/01/2022",
        endDate: "",
        description: "",
        lastChargedOn: "08/2022",
        nextCharge: "",
        gLAccount: "103: Rent Income",
        amount: "1,000.00",
        upcommingCharges: "",
        previousCharge: "1,000.00 ",
        reversed: "yes",
        chargeDate: "08/01/2022 "
      },
    ],
    leaseInformation: {
      leaseSigned: "--",
      monthToMonth: "Yes",
      leaseFrom: "01/13/2017",
      lastLeaseRenewal: "08/01/2022",
      insuranceRequirement: "No",
      leaseDocuments: [
        {
          document: "matthew-carey_07-31-2022.pdf",
          leaseDates: "08/01/2022 -",
          Status: "Fully Executed",
        },
        {
          document: "matthew-carey_07-31-2022.pdf",
          leaseDates: "08/01/2022 -",
          Status: "Fully Executed",
        },
        {
          document: "matthew-carey_07-31-2022.pdf",
          leaseDates: "08/01/2022 -",
          Status: "Fully Executed",
        },
      ],
    },
    financials: {
      depositPaid: "0.00",
      utilityBillingEnabled: "No",
      NSFFee: "45.00",
      EligibleForRentIncreaseOn: "02/01/2021"
    },
    pets: [
      {
        petsName: "Cat",
        type: "Persian",
        weight: "3",
        age: "1"
      },
      {
        petsName: "Dog",
        type: "Dog",
        weight: "4",
        age: "1"
      },
    ],
    vehicles: [
      {
        make: "car",
        model: "civic",
        color: "white",
        licenseNo: "768",
        year: "2013",
        permitNumber: "34"
      },
      {
        make: "car",
        model: "civic",
        color: "white",
        licenseNo: "768",
        year: "2013",
        permitNumber: "34"
      },
      {
        make: "car",
        model: "honda",
        color: "black",
        licenseNo: "768",
        year: "2013",
        permitNumber: "34"
      },
    ],
    tags: [
      {
        tag: "Health Issues"
      },
      {
        tag: "Submitted cdc Form"
      }
    ],
  },
];
